export const environment = {
  production: true,
  environmentName: "prod",
  baseUrl: window.location.origin + "/devspacexdb",
  // msRedirectUri: 'https://xdai.netxd.com',
  // msClientId: '91cb3aa8-4dc7-4604-af51-d92e7dd7ff67',
  // googleClientId: '89759643465-mt3532v09aj3flv2qtebkium2iitmonk.apps.googleusercontent.com',
  // appleClientId: 'com.xdai.netxd.com.xde',
  // recaptchaId: '6LePVggrAAAAAFk0xBhVtLIvPRu2Z5ytJ2b944U7',
  // googleAppId : '89759643465',
};
